import { MobilePricing } from "./MobilePricing";
export class Mobile {
  id: number|null;
  type: String;
  subscription: String;
  subscriptionMonthly: number;
  subscriptionUnique: number;
  extraCardData: String;
  extraCardDataMonthly: number;
  extraCardDataUnique: number;
  extraCardWatch: String;
  extraCardWatchMonthly: number;
  extraCardWatchUnique: number;
  quantity: number;

  constructor() {
    this.id = null;
    this.type = '';
    this.subscription = '';
    this.subscriptionMonthly = 0;
    this.subscriptionUnique = 0;
    this.extraCardData = '0';
    this.extraCardDataMonthly = 0;
    this.extraCardDataUnique = 0;
    this.extraCardWatch = '0';
    this.extraCardWatchMonthly = 0;
    this.extraCardWatchUnique = 0;
    this.quantity = 1;
  }

  static fromPriceList(price: MobilePricing) : Mobile  {
    var mobile = new Mobile();
    mobile.type = price.type;
    mobile.subscription = price.subscription;
    mobile.subscriptionMonthly = price.costMonthly;
    mobile.subscriptionUnique = price.costUnique;
    mobile.extraCardData = (price.extraCardData != null) ? price.extraCardData : '0';
    mobile.extraCardDataMonthly = (price.extraCardDataMonthly != null) ? price.extraCardDataMonthly : 0;
    mobile.extraCardDataUnique = (price.extraCardDataUnique != null) ? price.extraCardDataUnique : 0;
    mobile.extraCardWatch = (price.extraCardWatch != null) ? price.extraCardWatch : '0';
    mobile.extraCardWatchMonthly = (price.extraCardWatchMonthly != null) ? price.extraCardWatchMonthly : 0;
    mobile.extraCardWatchUnique = (price.extraCardWatchUnique != null) ? price.extraCardWatchUnique : 0;
    mobile.quantity = (price.quantity != null) ? price.quantity : 1;

    return mobile;
  }


}



// WEBPACK FOOTER //
// ./src/models/Mobile.ts